import { http } from '@/http';
import { SET_MOVIMENTO, SET_MOVIMENTO_FROM_API } from "./types";

export default {

    async [SET_MOVIMENTO_FROM_API]( { commit }, numeroMovimento) {

        if (!numeroMovimento) { return [];}
        
        const uri = `api/Tesouraria/MovimentoDeCaixaEmAberto/EntradaManual/${numeroMovimento}`
        
        const response = await http.get(uri)
            .then( response => {
                if ( response.status === 200 ) {
                    commit('setMovimento', response.data);
                    return Promise.resolve(response);
                } else {
                    return Promise.reject(response);
                }
            }
        )
            .catch ( (e) => {
                const error = {
                    status: e.status,
                    message: e.message,
                }

                error.message = e.status === 404 ? e.message.errorCode : e.message;
                error.message = e.status === 404 ? "error.load" : e.message;

                return Promise.reject({ error });
                
            }
        )

        return response;

    },

    [SET_MOVIMENTO] ( { commit }, movimento){
        commit ('setMovimento', movimento)
    }

}